export const AVAILABLE_LANGS = [
  { code: 'pl', label: 'PL' },
];
export function normalizeLang(raw){
  if(!raw) return 'pl';
  const lower = raw.toLowerCase();
  const base = lower.split('-')[0];
  return AVAILABLE_LANGS.find(l=>l.code===base) ? base : 'pl';
}
